import { render } from "./RelOption.vue?vue&type=template&id=0179f012&ts=true"
import script from "./RelOption.vue?vue&type=script&lang=ts"
export * from "./RelOption.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__